import type { PropsWithChildren } from 'react'

import { classNames } from '@/utils/helpers'

export const VerticalSeparator = ({
  className,
}: PropsWithChildren<{ className?: string }>) => {
  return <div className={classNames('h-5 w-[1px] border-l', className)} />
}
